<template>
	<el-container class="user">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-card class="screen-box">
				<el-form ref="form" :model="searchForm" :inline="true" size="small">
					<el-form-item label="用户手机:">
						<el-input v-model="searchForm.mobile" placeholder="请输入用户手机"></el-input>
					</el-form-item>
					<el-form-item label="用户账号:">
						<el-input v-model="searchForm.username" placeholder="请输入用户账号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
						<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
						<el-button @click="add()" icon="el-icon-plus" type="primary" size="small">新增</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="table-box">
				<el-table :data="tableList" id="table" border>
					<template v-for="(item, index) in tableLabel">
						<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
						</el-table-column>
					</template>
					<el-table-column label="操作" width="190">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.enabled" @change="switchChange(scope.row.enabled,scope.row.id)"></el-switch>
							<el-button type="text" size="mini" @click="edit(scope.row)" style="margin:0 5px;">编辑</el-button>
							<el-popconfirm title="您确定要删除吗？" @confirm="del(scope.row)">
								<el-button type="text" size="mini" slot="reference">删除</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</el-card>
		</el-main>
		<!-- 弹出层 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
			<el-form :model="form" label-width="70px">
				<el-form-item label="用户账号">
					<el-input placeholder="请输入用户账号" v-model="form.username" :disabled="disabled"></el-input>
				</el-form-item>
				<el-form-item label="用户密码">
					<el-input placeholder="请输入用户密码" v-model="form.password"></el-input>
				</el-form-item>
				<el-form-item label="用户手机">
					<el-input placeholder="请输入用户手机" v-model="form.mobile"></el-input>
				</el-form-item>
				<el-form-item label="昵称">
					<label slot="label">昵&emsp;&emsp;称</label>
					<el-input placeholder="请输入昵称" v-model="form.nickName"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="formSubmit()">确 定</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import { userPageApi,userDeleteApi,userEnabledApi,userSaveApi,userUpdateApi } from "@/axios/api";
	export default {
		name: "Log",
		data() {
			return {
				totalCount:0,
				pageSizes:[10],
				searchForm:{
					isSearchCount:true,
					page:1,
					limit:10,
					username:'',
					mobile:''
				},
				tableList: [],
				tableLabel: [{
					label: "用户账号",
					prop: "username"
				}, {
					label: "昵称",
					prop: "nickName"
				}, {
					label: "手机号码",
					prop: "mobile"
				}, {
					label: "创建时间",
					prop: "createTime"
				}],
				dialogFormVisible: false,
				dialogTitle:'新增',
				form: {
					username:'',
					password:'',
					mobile:'',
					nickName:''
				},
				openType:'',
				disabled:false
			}
		},
		created(){
			this.getData();
		},
		methods:{
			getData(){
				userPageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm.username = '';
				this.searchForm.mobile = '';
				this.searchForm.page = 1;
				this.getData();
			},
			//添加
			add(){
				this.form = {
					username:'',
					password:'',
					mobile:'',
					nickName:''
				};
				this.openType = 'add';
				this.dialogTitle = '新增';
				this.disabled = false;
				this.dialogFormVisible = true;
			},
			//编辑
			edit(row){
				this.form = row;
				this.form.password = '';
				this.openType = 'edit';
				this.dialogTitle = '编辑';
				this.disabled = true;
				this.dialogFormVisible = true;
			},
			formSubmit(){
				if(this.openType == 'edit'){
					userUpdateApi(this.form).then((res) => {
						if (res.code == 200){
							this.$message.success("编辑成功");
							this.dialogFormVisible = false;
							this.getData();
						}
					}).catch((err) => {});
				}else{
					userSaveApi(this.form).then((res) => {
						if (res.code == 200){
							this.$message.success("添加成功");
							this.dialogFormVisible = false;
							this.resetForm();
						}
					}).catch((err) => {});
				}
			},
			//删除
			del(row){
				userDeleteApi({id:row.id}).then((res) => {
					if (res.code == 200){
						this.$message.success("删除成功");
						this.getData();
					}
				}).catch((err) => {});
			},
			//开关负载
			switchChange(enabled, id){
				userEnabledApi({id:id,enabled:enabled}).then((res) => {
					if (res.code == 200){
						this.getData();
					}
				}).catch((err) => {});
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			}
		}
	}
</script>

<style lang="less" scoped>
	.screen-box{
		margin-left: 12px;
	}
	.table-box{
		margin-left: 12px;
		min-height: 83vh;
	}
</style>